import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="bg-brand-gray text-brand-navy" data-id="element-43" data-mp="1nv1l2blse3ze">
      <div className="mx-auto max-w-xl px-3 py-5 sm:px-5" data-id="element-44" data-mp="2blnh14iinxt1">
        <h2 id="faq" className="text-center font-display text-base font-extrabold uppercase sm:text-xl" data-id="element-45" data-mp="2flpl1kbq53bh">
          Preguntas frecuentes
        </h2>

        <div className="mt-2.5 space-y-1.5" data-id="element-46" data-mp="21sq4df07h32c">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <Reveal key={faq.q} delay={i * 0.015} className={`rounded-lg border-2 ${isOpen ? 'border-brand-blue' : 'border-brand-navy/10'} bg-white`} data-id="element-47" data-mp="2ui6to3sj43uc" data-mpi={i}>
                <h3 data-id="element-48" data-mp="1vnet2k16ke9c">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-2.5 rounded-lg px-3 py-2 text-left" data-id="element-49" data-mp="1rofqh62x8tl2">
                    <span className="font-display text-[0.8rem] font-bold leading-snug" data-id="element-50" data-mp="2fbxgox6jfjlx">
                      {faq.q}
                    </span>
                    <ChevronDownIcon size={16} className={`flex-shrink-0 text-brand-blue transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-51" data-mp="2oeyiwmsa8qkb" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-52" data-mp="p2dwjx2hqjpr">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-53" data-mp="2p4dk273lax7r">
                      <p className="px-3 pb-2 text-[0.78rem] leading-snug text-slate-700" data-id="element-54" data-mp="382y8fre3johp">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}